import * as betgalaxy from './OnRaceBets.styles.betgalaxy';
import * as betprofessor from './OnRaceBets.styles.betprofessor';
import * as betroyale from './OnRaceBets.styles.betroyale';
import * as fiestabet from './OnRaceBets.styles.fiestabet';
import * as goldenrush from './OnRaceBets.styles.goldenrush';
import * as juicybet from './OnRaceBets.styles.juicybet';
import * as junglebet from './OnRaceBets.styles.junglebet';
import * as puntgenie from './OnRaceBets.styles.puntgenie';
import * as questbet from './OnRaceBets.styles.questbet';
import * as sterlingparker from './OnRaceBets.styles.sterlingparker';
import * as puntcity from './OnRaceBets.styles.puntcity';
import * as vikingbet from './OnRaceBets.styles.vikingbet';
import * as volcanobet from './OnRaceBets.styles.volcanobet';
import * as wellbet from './OnRaceBets.styles.wellbet';
import * as sugarcastle from './OnRaceBets.styles.sugarcastle';
import * as buffalobet from './OnRaceBets.styles.buffalobet';
import * as oldgill from './OnRaceBets.styles.oldgill';
import * as titanbet from './OnRaceBets.styles.titanbet';
import * as slambet from './OnRaceBets.styles.slambet';
import * as gigabet from './OnRaceBets.styles.gigabet';
import * as betstride from './OnRaceBets.styles.betstride';
import * as templebet from './OnRaceBets.styles.templebet';
import * as goldenbet888 from './OnRaceBets.styles.goldenbet888';
import * as hyperbet from './OnRaceBets.styles.hyperbet';
import * as bet777 from './OnRaceBets.styles.bet777';
import * as chromabet from './OnRaceBets.styles.chromabet';
import * as bet575 from './OnRaceBets.styles.bet575';
import * as epicodds from './OnRaceBets.styles.epicodds';
import * as pyramidbet from './OnRaceBets.styles.pyramidbet';
import * as magnumbet from './OnRaceBets.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  junglebet,
  puntgenie,
  questbet,
  sterlingparker,
  puntcity,
  wellbet,
  vikingbet,
  volcanobet,
  sugarcastle,
  buffalobet,
  oldgill,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
